import LeadsStipulations from './LeadsStipulations'
export default LeadsStipulations
